import { HugeiconsIcon } from "@hugeicons/react";
import { Button } from "../ui/button";
import { Calendar03Icon, SearchIcon } from "@hugeicons/core-free-icons";
import { Typography } from "../ui/typography";

export const MobileSearchSummaryButton: React.FC<{
  destination: string;
  dateValue: string;
  onClick: () => void;
  error?: string;
}> = ({ dateValue, destination, onClick, error }) => (
  <Button
    variant="outline"
    className={`flex-1 justify-start rounded-lg px-3 py-2 h-auto gap-3.5 ${
      error ? "border-red-500" : ""
    }`}
    onClick={onClick}
  >
    <HugeiconsIcon icon={SearchIcon} className="size-5" />
    <div className="flex flex-col gap-1 items-start">
      <Typography
        variant="captionRegular"
        color={destination ? "black" : "black300"}
      >
        {destination || "مقصدت کجاست؟"}
      </Typography>
      <div className="flex items-center gap-1.5">
        <HugeiconsIcon icon={Calendar03Icon} size={15} />
        <Typography
          variant="captionRegular"
          color={dateValue ? "black" : "black300"}
          className="text-[10px]"
        >
          {dateValue || "انتخاب تاریخ"}
        </Typography>
      </div>
      {error && (
        <Typography className="text-xs text-red-500 mt-1">{error}</Typography>
      )}
    </div>
  </Button>
);
